import React from 'react'
import { MobileBrand, NavMobile, NavLinks, DropDown, DropDownContant, NavBtns } from './MobileNav_Style'
import { NavLink, Link } from "react-router-dom";

export default function NavBarMobile(props) {
    return (
        <NavMobile active={props.active}>
            <MobileBrand><h2>Educate</h2></MobileBrand>
            <NavLinks>
                <NavLink activeClassName="activeLink" exact to="/" className=" navLink">Home</NavLink>
                <NavLink activeClassName="activeLink" to="/about" className="navLink" href="#">ABout</NavLink>
                <NavLink activeClassName="activeLink" to="/courses" className="navLink" href="#">Courses</NavLink>
                <NavLink activeClassName="activeLink" to="/blogs" className="navLink" href="#">Blog</NavLink>
                <DropDown>
                    <a href ="/#">Pages</a>
                    <DropDownContant>
                        <li> <Link to="/singleCourse">Singal Course</Link></li>
                        <li><Link to="/singleTeacher" >Singal Teacher</Link></li>
                        <li> <Link to="/singleBlog"  >Singal Blog</Link></li>
                    </DropDownContant>
                </DropDown>
                <NavLink activeClassName="activeLink" to="/contact" className="navLink" >Contact</NavLink>
                <NavBtns>
                    <Link to="/signUp"> Sign Up</Link>
                    <Link to="/signIn"> Sign In</Link>
                </NavBtns>
            </NavLinks>
        </NavMobile>
    )
}
